import React, {useMemo} from "react";
import objectPath from "object-path";
import {useHtmlClassService} from "../../../_metronic/layout/_core/MetronicLayout";
import {Topbar} from "../topbar/Topbar";
import AnimateLoading from "../animate-loading/AnimateLoading";
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import {Link, NavLink} from "react-router-dom";

export function Header() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      )
    };
  }, [uiService]);

  // function getCurrentDate() {
  //   var d = new Date();

  //   return d.toLocaleDateString() + " " + d.toLocaleTimeString();
  // }

  function startTimer() {
    setInterval(() => {
      var now = new Date();
      var dateString =
        ("0" + now.getDate()).slice(-2) + "/" +
        ("0" + (now.getMonth()+1)).slice(-2) + "/" +
        now.getUTCFullYear() + " " +
        ("0" + now.getHours()).slice(-2) + ":" +
        ("0" + now.getMinutes()).slice(-2);

      var dateInfo = document.getElementsByClassName('current-date-info')[0]
      if (dateInfo)
        dateInfo.textContent = dateString;
    }, 1000);
  }

  startTimer();

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
        
      >


        <Link to="" className="header-logo">
          <img alt="logo"  height="50" src={toAbsoluteUrl("/media/svg/header/logo-color.svg")}/>
        </Link>
        <div className="current-date-info">
        </div>

        {/*begin::Container*/}
        <div className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}>
          
          <AnimateLoading />
          <div />
          {/*begin::Topbar*/}
          <Topbar />
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
